export const shouldRedirectToLogin = (pathname: string, responseUrl?: string): boolean =>
  pathname !== '/login' &&
  !responseUrl?.includes('/auth/user') &&
  !pathname.startsWith('/update-requirements') &&
  !pathname.startsWith('/update-loyalty') &&
  !pathname.startsWith('/contract-sign') &&
  !pathname.startsWith('/approval');
